import { createRoute, redirect } from '@tanstack/react-router';
import { isBooleanFeatureFlagEnabled } from 'src/integrations/feature-flags/feature-flags';
import { Route as pathlessAuthenticatedRoute } from '../route';
import { NotificationsHistoryPage } from './NotificationsHistoryPage';

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/notifications',
  component: NotificationsHistoryPage,
  beforeLoad: () => {
    if (isBooleanFeatureFlagEnabled('inbox-enabled', false)) {
      throw redirect({ to: '/inbox', search: { filter: 'notifications' } });
    }
  },
  loader: () => ({
    crumb: 'Notifications',
  }),
});
